import makeStyles from '@mui/styles/makeStyles';
import BasicButton from "./Buttons/BasicButton";
import { useMemo } from 'react';

const useStyles = makeStyles((theme) => ({
    primeButton: {
        padding: ".4rem 1rem",
        textDecoration: "none",
        justifyContent: "center",

        backgroundColor: theme.palette.primary.main,
        color: 'rgba(0, 0, 0, 0.87)',

        transition: "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        boxShadow: "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",


        '& svg path': {
            fill: 'currentColor',
        },
        '&:hover': {
            backgroundColor: theme.palette.primary.light,
            boxShadow: "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)",
        },
        '&:hover svg path': {
            fill: 'currentColor',
        }

    },
    btnNoText: {
        margin: theme.spacing(1),
        borderRadius: 0,
        fontWeight: 800,
        backgroundColor: theme.palette.primary.main,

        '&:hover': {
            backgroundColor: theme.palette.primary.light,
        },
        '& .MuiButton-startIcon': {
            marginRight: '0px',
        },

    }
}));

function PrimeButton({ children, component = null, icon, text, styles, isActive = false, className="", onClick,
    buttonProps = {}, ...props
}) {
    const classes = useStyles();

    const StartIcon = useMemo(() => icon && (() => icon), [icon]);

    const classArray = [
        classes.primeButton,
        !text ? classes.btnNoText : "",
        isActive ? classes.rootActive : null,
        className,
    ].filter(x => x);

    const displayProps = {
        className: classArray.join(" "),
        startIcon: StartIcon,
        ...(onClick ? {
            onClick,
        }:{}),
        style: styles,
        component: component,
        ...props,
        ...buttonProps,
    }

    return (
        <BasicButton {...displayProps}>
            {text ?? children}
        </BasicButton>
    );
}

export default PrimeButton;